import {ref} from "vue";
import useTools from "@/use/Tools";
import axios from "axios";

export default function useConfiguration() {
    const configurations = ref([]);
    const loading = ref(false);

    const {$swal} = useTools();

    function findAll() {
        loading.value = true;
        axios.get('/configurations').then(response => {
            configurations.value = response.data;
        }).finally(() => {
            loading.value = false;
        });
    }

    function save() {
        loading.value = true;
        axios.post('/configurations', configurations.value).then(() => {
            $swal.fire("Modifications Appliquées", "", "success");
        }).finally(() => {
            loading.value = false;
        });
    }


    return {
        configurations,
        loading,
        findAll,
        save,
    }
}